import { FC, useMemo } from 'react';
import { Box, IconButton, Typography, Stack, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
import keyBy from 'lodash/keyBy';

import { StepBody } from '@modules/Programs/components/StepBody';


type Props = {
  program: Programs.Program,
  stepEntry: Programs.StepEntry,
  onCloseClick: () => void,
  onViewClick: () => void,
}

export const StepOverview: FC<Props> = ({ program, stepEntry, onCloseClick, onViewClick }) => {
  const stepsMap = useMemo(() => keyBy(program.steps, 'id'), [program.steps]);

  const step = stepsMap[stepEntry.programStep];

  return (
    <Box p={3} bgcolor="rgba(46, 92, 107, 0.3)" borderRadius={3}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton size="small" sx={{ fontSize: 14 }} onClick={onCloseClick}>
          <Close fontSize="inherit"/>
        </IconButton>
      </Box>
      <Stack spacing={2}>
        <Typography textAlign="center" variant="h4" fontSize={18}>
          {step.title}
        </Typography>
        <StepBody body={step.bodyText} fontSize={14}/>
        <Box display="flex" justifyContent="center">
          <Button variant="outlined" onClick={onViewClick}>View</Button>
        </Box>
      </Stack>
    </Box>
  );
};